export default {
	data() {
		return {
			isFocused: null
		};
	},
	methods: {
		handleFocus(ev) {
			this.isFocused = true;
			this.$emit('focus', ev);
		},
		handleBlur(ev) {
			this.isFocused = false;
			this.$emit('blur', ev);
		}
	}
};
